import { MoreHorizontal } from 'lucide-react';
import {
  IconButton,
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@vnetwork/ui/primitives';

/**
 * Standard row-actions kebab for list pages. Use whenever a row has two or
 * more actions; a single action may stay a ghost IconButton. Lived in
 * compute/components/CrudBits originally — promoted here for all services.
 */
export function RowMenu({ items }: { items: { label: string; onSelect: () => void; danger?: boolean }[] }) {
  return (
    <div style={{ textAlign: 'right' }} onClick={(e) => e.stopPropagation()}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <IconButton variant="ghost" size="sm" aria-label="Actions">
            <MoreHorizontal size={16} />
          </IconButton>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {items.map((it) => (
            <DropdownMenuItem key={it.label} tone={it.danger ? 'danger' : undefined} onSelect={it.onSelect}>
              {it.label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}

/** "Showing X–Y of Z" caption for DataTable `footer` — keeps list pages consistent. */
export function showingRange(page: number, pageSize: number, pageCount: number, total: number): string {
  const start = pageCount ? (page - 1) * pageSize + 1 : 0;
  return `Showing ${start}–${(page - 1) * pageSize + pageCount} of ${total}`;
}
